export function save(key, value) {
  localStorage[key] = JSON.stringify(value);
}

export function load(key, def) {
  try {
    return JSON.parse(localStorage[key]) || def;
  } catch (ex) {
    return def;
  }
}
